import React from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';

function ResponsiveDialog(props) {
    var fullScreen = props.fullScreen,
        open = props.open,
        title = props.title,
        okText = props.okText,
        cancelText = props.cancelText,
        onCancel = props.onCancel,
        onOk = props.onOk,
        children = props.children;


    return React.createElement(
        Dialog,
        {
            fullScreen: fullScreen,
            open: open,
            onClose: onCancel,
            PaperProps: {
                style: {
                    maxWidth: '620px'
                }
            }
        },
        React.createElement(
            DialogTitle,
            null,
            title
        ),
        React.createElement(
            DialogContent,
            null,
            children
        ),
        React.createElement(
            DialogActions,
            null,
            React.createElement(
                Button,
                {
                    onClick: onCancel,
                    color: 'default'
                },
                cancelText
            ),
            React.createElement(
                Button,
                {
                    onClick: onOk,
                    color: 'primary'
                },
                okText
            )
        )
    );
}

ResponsiveDialog.defaultProps = {
    okText: 'Ok',
    cancelText: 'Cancel',
    title: '',
    open: false,
    showActions: true
};

ResponsiveDialog.propTypes = process.env.NODE_ENV !== "production" ? {
    showActions: PropTypes.bool,
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    okText: PropTypes.string,
    cancelText: PropTypes.string,
    onCancel: PropTypes.func,
    onOk: PropTypes.func,
    /* withMobileDialog */
    fullScreen: PropTypes.bool.isRequired
} : {};

export default withMobileDialog()(ResponsiveDialog);